import type { FaireProductEntity } from "../../entity_types/product";

export const p_8jcgrjkhxk: FaireProductEntity = {
  token: "p_8jcgrjkhxk",
  type: "product",
  name: "Everything Bagel Gym Snack - Plant-Based Protein Snack",
  brandToken: "b_6v6o5jk4x7",
  brandName: "Louisville Brands",
  imageUrl:
    "https://cdn.faire.com/fastly/2fad740ccd454b44533c318c3c334b4fe2b4cd72d6454aa954fdb347c80a403c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7c978b5b49e23952e3d8511c2956805f07856d76d0a5edbd9af98b8f159ec94c.png",
  ],
  priceDollars: 3.59,
  description:
    "No weak snacks. No excuses. Gym Snack is your plant-protein-powered swolemate that's ready to crush cravings and fuel your grind with gold, cheesy flavor that hits hard and lifts clean.\n\nEach bite hits with the crave-worthy blend of an everything bagel: savory garlic and onion, nutty sesame and poppy seeds, and just the right pop of sea salt. The flavor is layered and loaded, sticking to every crevice for maximum impact, with a lift of umami from coconut aminos and nutritional yeast that brings everything together.\n\nEach bag packs 30 grams of plant-based protein to fuel muscle recovery and strength, along with 4 grams of dietary fiber per bag to help you stay satisfied and focused. With only 3 grams of added sugar per serving, zero cholesterol, and ingredients that are gluten-free and non-GMO, it’s performance fuel you can feel good about. ",
  tags: [],
  msrpDollars: 5.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:21.321Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
